import { ViewerAPI } from 'thunderbolt-viewer-manager-types'
import { getDisplayedId, getFullId, getItemId, isDisplayedOnly, isRepeater } from '@wix/thunderbolt-commons'

const isMinusZero = (value: number) => 1 / value === -Infinity

const roundToNearestHalf = (num: number) => {
	const nearestHalf = Math.round(num * 2) / 2

	return isMinusZero(nearestHalf) ? 0 : nearestHalf
}

export const getNotRotatedAbsoluteTop = (absoluteTop: number, height: number, offsetHeight: number) =>
	roundToNearestHalf(absoluteTop + (height - offsetHeight) / 2)

export const getNotRotatedAbsoluteLeft = (absoluteLeft: number, width: number, offsetWidth: number) =>
	roundToNearestHalf(absoluteLeft + (width - offsetWidth) / 2)

export const getInflatedAncestors = (
	compId: string,
	compIdToAncestors: { [compId: string]: { allAncestors: Array<string>; ancestorsFromRootStructure: Array<string> } },
	structureAPI: ViewerAPI['structure']
): Array<string> => {
	const isRepeatedComponent = isDisplayedOnly(compId)
	if (!isRepeatedComponent) {
		return compIdToAncestors[compId]?.ancestorsFromRootStructure || []
	}

	const itemId = getItemId(compId)
	const compAncestors = compIdToAncestors[getFullId(compId)]
	let shouldInflate = true

	const compInflatedAncestors = compAncestors?.ancestorsFromRootStructure.map((nonInflatedAncestorId) => {
		if (shouldInflate) {
			// stop inflating if ancestor is the repeater component
			if (isRepeater(structureAPI.getStructure(nonInflatedAncestorId).componentType)) {
				shouldInflate = false
				return nonInflatedAncestorId
			}
			return getDisplayedId(nonInflatedAncestorId, itemId)
		} else {
			return nonInflatedAncestorId
		}
	})

	return compInflatedAncestors || []
}
